const TYPE_OF_TABLE_DATA = {
  TEXT: 'text',
  NUMBER: 'number',
  DATE: 'date',
  ACTION: 'action',
  TITLE: 'title',
};

export default TYPE_OF_TABLE_DATA;
